<div class="map-container">
    <div class="map-frame">
        <div class="map"
            [id]="leafletId"></div>
    </div>

    <div class="observation-frame mat-elevation-z8"
        [ngClass]="{'mobile': mobile}"
        *ngIf="selectedObservation">
        <div class="header-row">

            <div *ngIf="attachedTask"
                class="link-div">
                <a id="RouteToTaskButton"
                    class="target-info"
                    [routerLink]="'/Tasks/' + attachedTask.Id + '/Details'"
                    target="_blank">
                    {{ attachedTask.TaskId }} {{ attachedTask.Identifier }} {{ attachedTask.Name }}
                    <mat-icon class="icon-suffix"
                        matTooltip="{{ 'task.openTaskInNewTab' | blah }}"
                        matTooltipClass="hpo"
                        matTooltipPosition="right"
                        matTooltipDelay="500">open_in_new</mat-icon>
                </a>
            </div>

            <div *ngIf="!attachedTask"
                class="create-task-container">
                <button *ngIf="attachedTask === null"
                    style="margin: auto auto auto 0;"
                    mat-button
                    mat-stroked-button
                    [disabled]="creatingTaskFromObservation"
                    color="accent"
                    (click)="createTaskFromObservation()">
                    <mat-icon>add</mat-icon> {{ 'task.createNewTask' | blah | uppercase }}
                </button>
                <div *ngIf="creatingTaskFromObservation"
                    class="save-in-progress-note"><hpo-spinner [size]="20"></hpo-spinner>{{ 'task.creatingTask' | blah}}... </div>
            </div>

            <button mat-icon-button
                (click)="close()"> <mat-icon>close</mat-icon></button>

        </div>
        <div class="scrollable-content">
            <app-observation [mobile]="true"
                [observationId]="selectedObservation?.properties.Id"
                (taskLink)="attachedTask = $event">
            </app-observation>
        </div>
    </div>
    <div class="info-frame mat-elevation-z8"
        *ngIf="infoVisible">

        <div *ngIf="!infoActive"
            class="margin">{{'networkComponents.helpText' | blah }}</div>
        <div *ngIf="infoItems.data.length >= 50"
            class="margin">{{'networkComponents.moreItems' | blah }}</div>
        <div *ngIf="infoItems.data.length == 0"
            class="margin">{{'networkComponents.noItems' | blah }}</div>

        <table *ngIf="infoItems.data.length > 0"
            mat-table
            [dataSource]="infoItems">

            <ng-container matColumnDef="Id">
                <th mat-header-cell
                    *matHeaderCellDef> Id </th>
                <td mat-cell
                    *matCellDef="let element"> {{element.Id}} </td>
            </ng-container>

            <ng-container matColumnDef="ComponentType">
                <th mat-header-cell
                    *matHeaderCellDef>{{'networkComponents.componentType' | blah}}</th>
                <td mat-cell
                    *matCellDef="let element">{{'networkComponents.componentTypes.' + element.ComponentType | blah}}</td>
            </ng-container>

            <ng-container matColumnDef="Label">
                <th mat-header-cell
                    *matHeaderCellDef>{{'networkComponents.label' | blah}}</th>
                <td mat-cell
                    *matCellDef="let element">{{element.Label}}</td>
            </ng-container>

            <ng-container matColumnDef="Selected">
                <th mat-header-cell
                    *matHeaderCellDef></th>
                <td mat-cell
                    *matCellDef="let element">
                    <mat-checkbox [(ngModel)]="element.Selected"
                        (click)="toggleSelected(element)"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="CreateTask">
                <th mat-header-cell
                    *matHeaderCellDef></th>
                <td mat-cell
                    *matCellDef="let element">
                    <button mat-raised-button
                        [id]="'createTask-'+element.Id"
                        color="default"
                        (click)="createTask(infoCoords.lat, infoCoords.lng, element.Id, element.ComponentType, element.Label)">
                        <mat-icon>add</mat-icon>
                        {{ 'task.createNewTask' | blah | uppercase }}
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row
                *matHeaderRowDef="infoColumns"></tr>
            <tr mat-row
                *matRowDef="let row; columns: infoActive ? infoColumns : areaSelectedColumns;"></tr>
        </table>

        <div class="margin"
            *ngIf="infoCoords">
            {{'task.basicInformation.coordinates' | blah }}: {{ infoCoords.lat | number:'0.6' }} {{ infoCoords.lng | number:'0.6'}}
        </div>

        <div class="margin actions">
            <button mat-button
                id="closeInfo"
                (click)="closeInfo()">
                <mat-icon>close</mat-icon>
                {{ 'default.close' | blah | uppercase }}
            </button>

            <button *ngIf="!infoActive"
                mat-raised-button
                id="addComponentsToTask"
                color="accent"
                (click)="addComponentsToTask()">
                <mat-icon>add</mat-icon>
                {{ 'networkComponents.addToTask' | blah | uppercase }}
            </button>

            <button *ngIf="infoActive"
                mat-raised-button
                id="createTask"
                color="accent"
                (click)="createTask(infoCoords.lat, infoCoords.lng)">
                <mat-icon>add</mat-icon>
                {{ 'task.createNewTask' | blah | uppercase }}
            </button>
        </div>
    </div>
</div>